import { type ReactNode } from 'react'

import { KNLogo, KNSymbol } from 'components/KNIcon/KNLogo'

export const getLogo = (type: 'logo' | 'symbol', width: string, height: string, color:string): ReactNode => {
  if (type === 'symbol') {
    return (
      <KNSymbol
        sx={{
          width: width,
          height: height,
          color: color,
        }}
      />
    )
  }
  return (
    <KNLogo
      sx={{
        width: width,
        height: height,
        color: color,
      }}
    />
  )
}
